import React from 'react';
import ReactDOM from 'react-dom';
import PassurLogin from "./PassurLogin";
import { BrowserRouter } from 'react-router-dom';

ReactDOM.render(
    <BrowserRouter>
         <PassurLogin/> 
    </BrowserRouter>,
    document.querySelector('#root')
 );